import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Wand2 } from "lucide-react";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useEditor } from "./useEditorState";

export const isBookingSection = (s) => s.type === "react" && (!!s.props?.bookingKey || /kind="booking"/.test(s.code || "") || /prenot|booking|reserv/i.test(`${s.name} ${s.code || ""}`));
const guessMode = (s) => (/tavol|coperti|ristorant|pizzer|table/i.test(`${s.name} ${s.code || ""}`) ? "table" : "multi");

// Simulated booking UI -> the real universal widget, in the draft only: a version is saved first (undo from history), nothing is published.
export default function BookingManageLink({ s }) {
  const ed = useEditor();
  const [busy, setBusy] = useState(false);
  const convert = async () => {
    setBusy(true);
    try {
      const mode = guessMode(s);
      const { data } = await ed.api.get("/library/blocks");
      const b = data.blocks.find((x) => x.key === `booking-${mode}`);
      await ed.save();
      await ed.api.post(`/projects/${ed.id}/versions`, { label: `Prima della conversione di «${s.name}» in prenotazioni reali` });
      ed.updateSection(s.id, { name: /simulat/i.test(s.name) ? "Prenotazioni" : s.name, code: b.code, props: { ...structuredClone(b.props), title: typeof s.props?.title === "string" && s.props.title ? s.props.title : b.props.title } });
      await ed.save(); window.dispatchEvent(new Event("adm:project-changed"));
      toast.success("Sezione convertita nella bozza (versione salvata prima). Ora configura servizi e orari qui a destra, poi «Salva».");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2" data-testid="booking-manage-box">
      <p className="text-xs text-amber-800" data-testid="booking-manage-note">Questa sezione è solo grafica (simulata): non registra prenotazioni.</p>
      <p className="text-[11px] text-slate-500">Convertila nel widget reale: servizi, durata, orari, risorse e campi del modulo si configurano poi direttamente qui nell'editor. Il sito pubblicato non cambia finché non lo aggiorni tu.</p>
      <Button size="sm" className="w-full" onClick={convert} disabled={busy} data-testid="booking-convert-btn">{busy ? <Loader2 size={13} className="mr-1.5 animate-spin" /> : <Wand2 size={13} className="mr-1.5" />}Converti in widget reale ({guessMode(s) === "table" ? "tavolo" : "più servizi"})</Button>
    </div>
  );
}
